module.exports = __webpack_public_path__ + "static/media/ci.a58e55f4.svg";